import { columns } from './columns'
import createState from '../_defaults/state'
import createGetters from '../_defaults/getters'
import createMutations from '../_defaults/mutations'
import createActions from '../_defaults/actions'

/* -------- CONFIG ----------- */
export const apiEndpoint = '/api/comment'
export const namespace = 'comment'
export const clientRoute = '/company/comment'
export const dependencies = []
export const params = {
  include: ''
}
/* --------------------------- */

/* -------- LABELS ----------- */
const titleColumn = 'lastUpdate'
const subtitleColumn = ''
const infoColumns = ['commentText']
/* --------------------------- */

const state = {
  columns,
  apiEndpoint,
  namespace,
  dependencies,
  clientRoute,
  params,
  titleColumn,
  subtitleColumn,
  infoColumns
}

export default {
  namespaced: true,
  state: createState(Object.assign(state, { namespace })),
  getters: createGetters(),
  mutations: createMutations(),
  actions: createActions()
}
